module.exports = __webpack_public_path__ + "img/image25.74df16b9.png";